import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { BaseComponent, IBaseComponentProps } from "../../Common/BaseComponent/BaseComponent";

export interface ICitationListProps extends IBaseComponentProps
{
    onSelect?: Function;
    onDelete?: (number) => void;
    readOnly?: boolean;
}

export class CitationList extends BaseComponent<ICitationListProps>
{
    private _citations: any[] = [];
    private _tblCitations: HTMLTableElement;

    constructor(props: ICitationListProps)
    {
        super(props);
    }

    public getData()
    {
        return this._citations;
    }

    public setData(data)
    {
        this._citations = data || [];
        this.renderCitations();
    }

    private _onLstClick(event)
    {
        var target = $$.getParent(event.target, "tr");
        if (!target)
        {
            return;
        }

        let index = $(target).index();
        var anchor = $$.getParent(event.target, "a");
        if (anchor && anchor.className === "deleteImage")
        {
            if (this.props.onDelete)
            {
                this.props.onDelete(index);
            }
            this._citations.splice(index, 1);
            this.renderCitations();
        }
        else if (target)
        {
            if (this.props.onSelect)
            {
                this.props.onSelect(index);
            }
        }
    }

    public renderCitations()
    {
        this._tblCitations.innerHTML = "";

        $$.appendChild(this._tblCitations, 
        this._citations?.map((item, index) =>
        {
            //source priority
            var sourceId = item.SourceId;
            var sourceClass = "";
            var sourceText = "";
            var sourceTitle = "";
            if (sourceId === 1)
            {
                sourceClass = "primary";
                sourceText = "1st";
                sourceTitle = "Primary";
            }
            else if (sourceId === 2)
            {
                sourceClass = "secondary";
                sourceText = "2nd";
                sourceTitle = "Secondary";
            }
            else if (sourceId === 3)
            {
                sourceClass = "tertiary";
                sourceText = "3rd";
                sourceTitle = "Tertiary";
            }

            var parts = [];

            if (item.Author)
            {
                parts.push(item.Author + ".");
            }

            if (item.Title)
            {
                parts.push("\"" + item.Title + "\".");
            }

            var commaParts = [];
            if (item.ContainerTitle)
            {
                commaParts.push("<em>" + item.ContainerTitle + "</em>");
            }

            if (item.Date)
            {
                commaParts.push(item.Date.localeFormat("d"));
            }

            if (item.URL)
            {
                commaParts.push("<a href=\"" + item.URL + "\" target=\"_blank\">" + item.URL + "</a>");
            }

            if (item.PageNumber)
            {
                commaParts.push("p. " + item.PageNumber);
            }

            if (item.ParagraphNumber)
            {
                commaParts.push("par. " + item.ParagraphNumber);
            }

            if (item.Issue)
            {
                commaParts.push("iss. " + item.Issue);
            }

            if (item.Volume)
            {
                commaParts.push("vol. " + item.Volume);
            }

            var allParts = parts.join(" &nbsp;&nbsp;") + " " + commaParts.join(", &nbsp;");

            return (
                <tr key={sourceId}>
                    <td>[{index + 1}]</td>
                    <td><span className={"sourceWrapper " + sourceClass}>
                        <span className="source">{sourceText}</span>
                        <span style={{ display: "inline-block", textAlign: "center", width: "68px" }}>{sourceTitle}</span>
                    </span>
                    </td>
                    <td>
                        <span dangerouslySetInnerHTML={{ __html: allParts }} />

                        {!item.Notes ? null : (<div className="citationNotes">{item.Notes}</div>)}
                    </td>
                    {this.props.readOnly ? null : (<td><a href="javascript:void(0);" style={{ marginLeft: "5px" }} className="deleteImage" /></td>)}
                </tr>
            );
        }));
    }

    public render()
    {
        return (
            <div ref={(ref) => this._registerContainer(ref)}>
                <table className="citationList" onClick={this._onLstClick.bind(this)} ref={(ref) => this._tblCitations = ref}>
                </table>
            </div>
        );
    }
}

